import { getJwt } from '@app/helpers';
import Axios from 'axios';
import api, { Notifiable } from './api';
import { trackPromise } from 'react-promise-tracker';
import { notification } from '@digital/ui';

export interface AContratar extends Notifiable {
    ordemInvestimentoId: string;
    valor: number;
    totalFormatado: string;
}

export const updateValorModuloAContratar = (aContratar: AContratar) => {
    return api.put<AContratar>(`acontratar/atualizarValorAContratar/${aContratar.ordemInvestimentoId}`, aContratar);
}

export const getConstruirConsolidadoPluriAnual = (id: string) => {
    return api.get<Notifiable>(`routines/construirConsolidadoPluriAnual/${id}`);
};

export const verificarStatusDoProcessoDeAtualizacao = () => {
    return api.get<Notifiable>(`routines/verificarStatusDoProcessoDeAtualizacao`,
        setTimeout(() => { }, 230));
};

export const atualizarTabelaADistribuirAContratar = (projetoId: string) => {
    return api.get<Notifiable>(`routines/construirConsolidadoPluriAnual/${projetoId}`, setTimeout(() => { }, 230));
};


// export const atualizarTabelaADistribuirAContratar = async (projetoId: string, atualizarTela: () => void) => {
//     notification.info('Iniciando processo de atualização');
//     const urlBase = window.location.origin;
//     await trackPromise(
//         Axios.get(`${urlBase}/api/routines/construirConsolidadoPluriAnual/${projetoId}`, {
//             timeout: 230,
//             headers: {
//                 Authorization: `Bearer ${getJwt()}`,
//             },
//         }).then((resp) => {
//             if (resp.data.invalid) {
//                 notification.error(resp.data.notifications[0].message);
//             } else {
//                 notification.success('Tabela de A CONTRATAR PLURIANUAL está atualizada.');
//                 atualizarTela();
//             }
//         }).catch((resp) => {

//         }).finally(() => {
//             notification.success('finally');
//         })
//     ).then(() => {

//     });

// }
